import { render, staticRenderFns } from "./Present.vue?vue&type=template&id=f6f1c96e"
import script from "./Present.vue?vue&type=script&lang=js"
export * from "./Present.vue?vue&type=script&lang=js"
import style0 from "./Present.vue?vue&type=style&index=0&id=f6f1c96e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports